import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";
import ArtistName from "~/Components/Elements/ArtistName";
import ArtistFavoritesContainer from "~/Containers/ArtistFavoritesContainer";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { getArtistTracks } from "~/api/getArtist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import styled from "styled-components";

export const WrapperNoFav = styled.section`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 12px;
`;

const Card = styled(Link)`
  display: block;
  overflow: hidden;
  color: #2c2c4a;
  text-decoration: none;
  background: #fff;
  border: 1px solid #e4e0f2;
  border-radius: 10px;

  &:hover {
    color: #2c2c4a;
    text-decoration: none;
    border-color: #66c;
  }

  img {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
  }
`;

const Initial = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  background: #f7f6fc;
  color: #66c;
  font-size: 40px;
  font-weight: 600;
`;

const Name = styled.span`
  display: block;
  padding: 10px 12px 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
`;

const artistPath = (name) => `/artist/${encodeURIComponent(name)}`;

const coverFromArtist = (artist) => {
  if (!artist || (!artist.img_url && !artist.media_id && !artist.track_id)) return null;
  return {
    id: artist.track_id,
    img_url: artist.img_url,
    media_id: artist.media_id,
    sc_url: artist.sc_url,
    artist: artist.name,
    title: artist.name,
  };
};

const FavoriteArtistCard = ({ artist }) => {
  const [cover, setCover] = useState(() => coverFromArtist(artist));

  useEffect(() => {
    if (cover) return undefined;
    let cancelled = false;
    getArtistTracks(axios, artist.name, 1)
      .then(({ data }) => {
        const tracks = Array.isArray(data) ? data : [];
        const track = tracks.find((item) => item.img_url || item.media_id) || tracks[0];
        if (!cancelled && track) setCover(track);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [artist.name, cover]);

  return (
    <Card to={artistPath(artist.name)}>
      {cover ? (
        <TrackImage link={false} width="100%" alt={artist.name} track={cover} />
      ) : (
        <Initial>{(artist.name || "?").slice(0, 1)}</Initial>
      )}
      <Name>{artist.name}</Name>
    </Card>
  );
};

const ProfileFavoriteArtists = ({ dir, isOwner }) => (
  <ArtistFavoritesContainer
    dir={dir}
    render={({ artists }) => {
      if (artists.length === 0 && !isOwner) return null;

      return (
        <div className="profile-right-nav">
          <h3>Favorite Artists</h3>
          {artists.length === 0 && isOwner ? (
            <WrapperNoFav>
              You haven't added any favorites yet.
              <br />
              <br />
              Tip: Click the {` `}
              <FontAwesomeIcon icon={faStarOutline} /> {` `}
              on an artist page to add as a favorite. For example: <ArtistName track={{ artist: `Sorcerer` }} link={true} />
            </WrapperNoFav>
          ) : (
            <Grid>
              {artists.map((artist) => (
                <FavoriteArtistCard key={artist.id || artist.name} artist={artist} />
              ))}
            </Grid>
          )}
        </div>
      );
    }}
  />
);

export default ProfileFavoriteArtists;
